export const setCurrentCustomUI = (currentCustomUI: any) => {
  window.parent.primingcloud.context.setCurrentCustomUI(currentCustomUI)
}

export const getCurrentCustomUI = () => {
  window.parent.primingcloud.context.getCurrentCustomUI()
}

export const getFileByKey = (key: string) => {
  window.parent.primingcloud.context.getFileByKey(key)
}

export const putStorage = (key: string, value: any) => {
  window.parent.primingcloud.context.putStorage(key, value)
}

export const getStorage = (key: string) => {
  window.parent.primingcloud.context.getStorage(key)
}

export const getCustomerName = (): string => {
  const customer = window.parent.primingcloud.context.getCustomerName()
  return customer
}
export const getApplicationName = (): string => {
  const application = window.parent.primingcloud.context.getApplicationName()
  return application
}
